import React, { useEffect, useReducer } from "react";
import ThreeDotsIcon from "../../icons/ThreeDotsIcon";
import CommentIcon from "./../../icons/CommentIcon";
import RetweetIcon from "./../../icons/RetweetIcon";
import ShareIcon from "./../../icons/ShareIcon";
import { fToNowAr } from '../../utils/format'
import logoImg from '../../static/images/logo.png';
import TextButton from "./../Button/TextButton/TextButton";
import useComponentVisible from "./../../CustomHooks/useComponentVisible";
import classNames from "classnames";
import Linkify from "linkify-react";
import "linkify-plugin-hashtag";
import "linkify-plugin-mention";
import moment from "moment";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { SET_TWEET_TYPE } from "../../store/model/modelSlice";
import {
  deleteTheRetweet,
  upvoteOpenProject,
  unlikeTheTweet,
  postTheRetweet,
  bookmarkTweet,
  removeBookmarkTweet,
  reactToProject,
} from "../../services/tweetService";
import TweetOptions from "../Options/TweetOptions";
import { selectCurrentUser } from "../../store/user/userSelector";
import { selectGuestUser } from "../../store/guest/guestSelector";
import tweetReducer, {
  initialState,
  FETCHING_TWEET_SUCCESS,
  CONSTITUTION_TWEET_LIKED_SUCCESS,
  TWEET_LIKED_FAILED,
  TWEET_RETWEETED_SUCCESS,
  TWEET_RETWEETED_FAILED,
  TWEET_BOOKMARK_SUCCESS,
  TWEET_BOOKMARK_FAILED,
  TWEET_REMOVEBOOKMARK_SUCCESS,
  TWEET_REMOVEBOOKMARK_FAILED,
} from "../../store/Tweet/tweetSlice";
import cogoToast from "cogo-toast";
import Video from "../../subcomponents/Video";
import { AnimatePresence, motion } from "framer-motion";
import { BASE_WEB_URL } from "../../CONSTANTS";
const linkProps = {
  onClick: (event) => {
    console.log(1);
    event.stopPropagation();
  },
};
const options = {
  className: () => "default-link",
  formatHref: {
    hashtag: (href) => "/search?c=trend&q=" + encodeURIComponent(href),
    mention: (href) => "/" + href.substr(1),
  },
  format: {
    url: (value) => (value.length > 20 ? value.slice(0, 20) + "…" : value),
    hashtag: (value) => (value.length > 20 ? value.slice(0, 20) + "…" : value),
    mention: (value) => (value.length > 20 ? value.slice(0, 20) + "…" : value),
  },
  target: {
    url: "__blank",
    email: null,
  },
  attributes: linkProps,
};

export default function ResultTweet({
  tweet: propTweet,
  isParentTweet,
  className,
  newlook,
}) {
  const state = useSelector((state) => state);
  const currentUser = selectCurrentUser(state);
  const guestUser = selectGuestUser(state);
  const tweetClasses = classNames("tweet-link", className);
  const navigate = useNavigate();
  // const dispatch = useDispatch();
  const [{ tweet, fetching }, dispatch] = useReducer(
    tweetReducer,
    initialState
  );
  useEffect(() => {
    if (propTweet) {
      dispatch(FETCHING_TWEET_SUCCESS(propTweet));
    }
  }, [propTweet]);
  const {
    ref: tweetOptionsRef,
    isVisible: istweetOptions,
    setIsVisible: settweetOptions,
  } = useComponentVisible(false);
  const { ref: retweetRef, isVisible: reweetOptonsVisible } =
    useComponentVisible(false);
  const {
    ref: saveOptionsRef,
    isVisible: saveOptonsVisible,
    setIsVisible: setsaveOptionsComponentVisible,
  } = useComponentVisible(false);
  const showTweetOptions = (e) => {
    e.stopPropagation();
    // OR
    e.preventDefault();
    settweetOptions(true);
  };
  const showSaveTweetOptions = (e) => {
    e.stopPropagation();
    // OR
    e.preventDefault();
    setsaveOptionsComponentVisible(true);
  };
  const retweetOptionsClassnames = classNames("retweet-options", {
    show: reweetOptonsVisible,
  });

  const savetweetOptionsClassnames = classNames(
    "tweet-options-model",
    "save-options",
    {
      show: saveOptonsVisible,
    }
  );
  const getImage = (topic_assets) =>{
    if(!topic_assets) return logoImg;
    let i = topic_assets.findIndex(el => el.asset_type != 'audio' && el.asset_type != 'video' && el.asset_type != 'pdf');
    if(i > -1){
      return BASE_WEB_URL + topic_assets[i].asset_file;
    }else{
      return logoImg;
    }
  } 
  const handelTweetLike = async (e) => {
    e.stopPropagation();
    // OR
    e.preventDefault();
    if (!tweet.is_voted) {
      await reactToProject(tweet.id, 'approve');
      cogoToast.success("تم تأييد الاستفتاء");
      dispatch(CONSTITUTION_TWEET_LIKED_SUCCESS({
        vote_type: 'approve',
        vote_count_type: 'approved_count'
    }));
    } else {
      // dispatch(TWEET_LIKED_FAILED());
      // await unlikeTheTweet(tweet._id);
    }
  };
  const handelTweetReply = (e) => {
    e.stopPropagation();

    dispatch(
      SET_TWEET_TYPE({ type: "tweetReply", retweet: null, tweet: tweet })
    );
    navigate("/compose/tweet");
  };
  const handelRetweet = async (e) => {
    // this time uing diffrent method
    e.stopPropagation();
    // OR
    e.preventDefault();

    if (!tweet.isRetweeted) {
      try {
        dispatch(TWEET_RETWEETED_SUCCESS());
        await postTheRetweet(tweet._id);
      } catch (error) {
        dispatch(TWEET_RETWEETED_FAILED());
      }
    } else {
      try {
        dispatch(TWEET_RETWEETED_FAILED());
        await deleteTheRetweet(tweet._id);
      } catch (error) {
        dispatch(TWEET_RETWEETED_SUCCESS());
      }
    }

    // dispatch(postRetweet(tweet))
  };
  const handelLinkCopy = (e) => {
    e.stopPropagation();
    const link =
      window.location.origin +
      "/status/" +
      tweet.id;
    navigator.clipboard.writeText(link);
    cogoToast.success("تم نسخ الرابط بنجاح");
  };

  const handelTweetBookmark = async (e) => {
    e.stopPropagation();
    try {
      dispatch(TWEET_BOOKMARK_SUCCESS());
      await bookmarkTweet(tweet._id);
      cogoToast.success("Bookmarked successfully!");
    } catch (error) {
      cogoToast.error(error.message);
      dispatch(TWEET_BOOKMARK_FAILED());
    }
  };
  const handelTweetRemoveBookmark = async (e) => {
    e.stopPropagation();
    try {
      dispatch(TWEET_REMOVEBOOKMARK_SUCCESS());
      await removeBookmarkTweet(tweet._id);
      cogoToast.success("Bookmark removed successfully!");
    } catch (error) {
      cogoToast.error(error.message);
      dispatch(TWEET_REMOVEBOOKMARK_FAILED());
    }
  };
  const handelShareTweet = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!navigator.canShare) {
      return cogoToast.error("Sharing not supported!");
    }

    const blob = await fetch(tweet.pic).then((r) => r.blob());
    const data = {
      title: "Tweet",
      files: [
        new File([blob], "file.png", {
          type: blob.type,
        }),
      ],
      text: tweet.caption,
      url: `https://zwitter.netlify.app/${tweet.user.username}/status/${tweet._id}`,
    };
    navigator.share(data);
  };
  return !fetching ? (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      onClick={() =>
        navigate("/status/" + tweet.id)
      }
      className={tweetClasses}
    >
      <div className="tweet tweet-container" style={{dir: 'rtl'}}>
        <div className="profile-pic-container">
          <img src={getImage(tweet.topic_assets)} alt="user-pic" className="profile-pic" />
        </div>
        <div className="tweet-content">
          <div className="tweet-content-header">
            <div className="tweet-header-child">
              <span className="tweet-content-child timestamp">
                {fToNowAr(tweet.created_at)}
              </span>
            </div>

            <div className="tweet-header-child">
              <span className="tweet-content-child timestamp">
                {tweet.topic_category_id === 1 ? 'قرار مجلس' : tweet?.state?.name ?  tweet?.state?.name : tweet?.locality?.name }
              </span>
            </div>

            <div className="tweet-header-child">
              <span className="tweet-content-child timestamp">
                المعرف: {tweet?.id}
              </span>
            </div>
           
          </div>
          <div className="tweet-content-text">
            <p className="tweet-text">
              {<Linkify options={options}>{tweet.title}</Linkify>}
            </p>
          </div>
          <div className="tweet-content-image-container">
            {tweet.media_type === 1 && tweet.pic && (
              <img
                src={tweet.pic}
                alt="tweet-pic"
                className="tweet-content-image"
              />
            )}
            {tweet.media_type === 2 && <Video src={tweet.video_src} />}
          </div>
          {!newlook && (
            <div className="tweet-actions">
              <div className="wrap-tweet-actions-child">
                {/* <div className=" tweet-actions-child tweet-comment">
                  <div className="tweet-icon">
                    <TextButton
                      className="tweet-icon-wrap"
                      onClick={handelTweetReply}
                    >
                      <CommentIcon
                        fill={"#536471"}
                        height="20px"
                        width="20px"
                      />
                    </TextButton>

                  </div>

                  <span className="tweet-comment-count">
                    {tweet.upvote_count}
                  </span>
                </div>
                <div
                  className="tweet-actions-child tweet-retweet"
                  ref={retweetRef}
                >
                  <div className="tweet-icon">
                    <TextButton
                      className="tweet-icon-wrap"
                      onClick={handelRetweet}
                    >
                      <RetweetIcon
                        fill={
                          tweet.isRetweeted
                            ? "rgba(29, 155, 240, 0.8)"
                            : "#536471"
                        }
                        height="20px"
                        width="20px"
                      />
                    </TextButton>

                  </div>
                  <div className={retweetOptionsClassnames}>
                    <div className="retweet-options-child retweet-btn-container">
                      <RetweetIcon
                        fill={"#536471"}
                        height="20px"
                        width="20px"
                      />
                      <TextButton className="retweet-btn">Retweet</TextButton>
                    </div>
                    <div className="retweet-options-child quote-tweet-container">
                      <i className="fas fa-pencil-alt"></i>
                      <TextButton className="quote-btn">Quote tweet</TextButton>
                    </div>
                  </div>

                  <span className="tweet-comment-count">
                    {tweet.retweetCount}
                  </span>
                </div> */}
                <div className="tweet-actions-child like-tweet">
                  <div className="tweet-icon like-icon">
                    <TextButton
                      className="tweet-icon-wrap"
                    >
                      <i
                        className={
                            "fas fa-person"
                        }
                        style={{
                          // color: tweet.is_voted ? "light-red" : "#536471",
                        }}
                      ></i>
                    </TextButton>

                  </div>

                  <span className="tweet-comment-count">
                   عدد المؤيدين {tweet.approved_count}
                  </span>
                </div>
              </div>

              <div className="tweet-actions-child save-tweet-options">
                <div
                  className="tweet-icon tweet-options-container"
                  ref={saveOptionsRef}
                >
                  <TextButton
                    onClick={showSaveTweetOptions}
                    className="tweet-options-btn"
                  >
                    <ShareIcon fill={"#536471"} height="18px" width="18px" />
                  </TextButton>
                  <AnimatePresence>
                    {saveOptonsVisible && (
                      <motion.ul
                        className={savetweetOptionsClassnames}
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ y: 50, opacity: 0 }}
                      >
                        <li className="tweet-options-model-item">
                          <span className="tweet-options-model-icon">
                            <i className="fas fa-link"></i>
                          </span>
                          <TextButton
                            className="tweet-options-model-btn"
                            onClick={handelLinkCopy}
                          >
                            نسخ الرابط للمشروع
                          </TextButton>
                        </li>
                      </motion.ul>
                    )}
                  </AnimatePresence>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </motion.div>
  ) : null;
}
